import * as HeroSections from "./Front/index";
import * as WorkSections from "./Work/index";
import Contact from "./Contact";

const Components = {
  Hero: {
    coords: {
      cam: { x: 108.83, y: 69.58000000000001, z: -15.640000000000018 },
      target: { x: 0, y: 0, z: 0 }
    },
    time: 900,
    path: "/",
    children: ["Hero1", "Hero2", "Hero3", "Hero4"]
  },

  Hero1: {
    component: HeroSections.Hero1,
    coords: {
      cam: { x: 108.83, y: 69.58000000000001, z: -15.640000000000018 },
      target: { x: 0, y: 0, z: 0 }
    },
    time: 900,
    path: "/hero1"
  },
  Hero2: {
    component: HeroSections.Hero2,
    coords: {
      cam: {
        x: 102.11081967996182,
        y: 61.07598957804284,
        z: 7.409223028481314
      },
      target: {
        x: 32.403561216559005,
        y: 2.7473507789979372,
        z: -35.89501916137398
      }
    },
    time: 900,
    path: "/hero2"
  },
  Hero3: {
    component: HeroSections.Hero3,
    coords: {
      cam: { x: 84.758138458203, y: 90.91578319958602, z: -11.63022264409041 },
      target: {
        x: 63.9209129158206,
        y: 22.7013903059061,
        z: -31.417283591299338
      }
    },
    // background: "#AAAAAA",
    time: 900,
    path: "/hero3"
  },
  Hero4: {
    component: HeroSections.Hero4,
    coords: {
      cam: {
        x: 136.5490082124075,
        y: -56.121842710302786,
        z: 503.0715379276186
      },
      target: {
        x: 153.84967622875055,
        y: -34.573298628051695,
        z: -59.59333417973528
      }
    },
    background: "#444444",
    time: 900,
    path: "/hero4"
  },

  Contact: {
    component: Contact,
    coords: {
      cam: {
        x: 172.42589818574433,
        y: -9.921710532965278,
        z: 5.931633114974005
      },
      target: {
        x: 29.197929782434386,
        y: 159.45040601163217,
        z: -10.892164732891885
      }
    },
    time: 900,
    path: "/contact",
    children: ["Contact"]
  },

  Work: {
    coords: {
      cam: {
        x: 65.99936939398441,
        y: 100.53939345817736,
        z: -25.229983402764866
      },
      target: {
        x: 55.19459722873771,
        y: 23.632876626402997,
        z: -31.512604116665283
      }
    },
    time: 900,
    path: "/work",
    children: ["Shopiteka", "DekoCom", "OEE", "Avis", "DekoSupport"]
  },

  Shopiteka: {
    component: WorkSections.Shopiteka,
    coords: {
      cam: {
        x: 65.99936939398441,
        y: 100.53939345817736,
        z: -25.229983402764866
      },
      target: {
        x: 55.19459722873771,
        y: 23.632876626402997,
        z: -31.512604116665283
      }
    },
    time: 900,
    path: "/work/shopiteka"
  },

  DekoCom: {
    component: WorkSections.DekoCom,
    coords: {
      cam: { x: 64.68217203150918, y: 96.4938267448783, z: -23.6186359784408 },
      target: {
        x: 59.089728469024,
        y: 22.900625508261864,
        z: -29.247708178464197
      }
    },
    time: 900,
    path: "/work/dekocom"
  },

  OEE: {
    component: WorkSections.OEE,
    coords: {
      cam: {
        x: 66.11829179711805,
        y: 96.61441215284445,
        z: -28.309742698737466
      },
      target: {
        x: 64.34751108510801,
        y: 22.7013903059061,
        z: -31.866522732631395
      }
    },
    time: 900,
    path: "/work/oee"
  },

  Avis: {
    component: WorkSections.Avis,
    coords: {
      cam: {
        x: 22.87102276707573,
        y: 97.7118015615852,
        z: -32.123611619079725
      },
      target: {
        x: 21.8824836084471,
        y: 23.79877971464686,
        z: -35.971876016362124
      }
    },
    time: 900,
    path: "/work/avis"
  },

  DekoSupport: {
    component: WorkSections.DekoSupport,
    coords: {
      cam: {
        x: 9.748334244009762,
        y: 97.04671707143929,
        z: -15.978490206521222
      },
      target: {
        x: 8.759795085381132,
        y: 23.133695224500944,
        z: -19.82675460380362
      }
    },
    time: 900,
    path: "/work/dekosupport"
  }
};

export default Components;



// WEBPACK FOOTER //
// ./src/components/ComponentList.js